import * as React from 'react';
import styled from 'styled-components';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import penn_storage_logo from 'src/assets/penn_storage_logo.svg';
import penn_storage_logo_inverted from 'src/assets/penn_storage_logo_inverted.svg';
import Navbar from 'reactstrap/lib/Navbar';

interface NavBarProps {
  colorinverted?: number;
}

const NavBarButton = styled.a`
  font-style: normal;
  line-height: normal;
  font-size: 14px;
  color: ${(p: NavBarProps) => (p.colorinverted === 1 ? '#ffffff' : '#00144D')} !important;
  font-weight: normal;
  cursor: pointer;

  :hover {
    color: ${(p: NavBarProps) =>
      p.colorinverted === 1 ? '#ffffff' : 'rgba(0, 20, 77, 0.6)'} !important;
  }
`;

const NavBarContainer = styled(Navbar)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 88px;
  left: 0px;
  background: ${(p: NavBarProps) => (p.colorinverted === 1 ? '#00144D' : '#ffffff')};
  padding: 0px !important;

  max-width: 100vw;

  ${NavBarButton} {
    margin-right: 30px;
  }
`;

const LogoImage = styled.img`
  height: 21px;
  margin-left: 45px;

  cursor: pointer;
`;

const NavBarButtonContainer = styled.a`
  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 134px;
  height: 40px;
  border: 1px solid;
  border-color: ${(p: NavBarProps) => (p.colorinverted ? '#ffffff' : '#00144D')};
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  line-height: normal;
  font-size: 14px;
  font-weight: bold;
  color: ${(p: NavBarProps) => (p.colorinverted ? '#ffffff' : '#00144D')} !important;
  cursor: pointer;

  :hover {
    text-decoration: none;
    background-color: ${(p: NavBarProps) => (p.colorinverted ? '#ffffff' : '#00144D')} !important;
    color: ${(p: NavBarProps) => (p.colorinverted ? '#00144D' : '#ffffff')} !important;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-left: 45px;
  margin-right: 45px;

  @media (max-width: 575.98px) {
    ${NavBarButtonContainer} {
      display: none;
    }
  }
`;

interface props extends RouteComponentProps<any> {
  colorInverted?: boolean;
}

class NavBar extends React.Component<props, any> {
  render() {
    return (
      <NavBarContainer colorinverted={this.props.colorInverted ? 1 : 0}>
        <LogoImage
          src={this.props.colorInverted ? penn_storage_logo_inverted : penn_storage_logo}
          alt="logo"
          onClick={() => this.props.history.push('/')}
        />
        <ButtonGroup>
          <NavBarButton
            colorinverted={this.props.colorInverted ? 1 : 0}
            onClick={() => this.props.history.push('/about-us')}
          >
            About Us
          </NavBarButton>
          <NavBarButton
            colorinverted={this.props.colorInverted ? 1 : 0}
            onClick={() => (window.location.href = 'mailto:penn@storewith.co')}
          >
            Contact
          </NavBarButton>
          <NavBarButton
            colorinverted={this.props.colorInverted ? 1 : 0}
            onClick={() => this.props.history.push('/faq')}
          >
            FAQs
          </NavBarButton>
          <NavBarButtonContainer
            colorinverted={this.props.colorInverted ? 1 : 0}
            onClick={() => this.props.history.push('/become-a-host')}
          >
            Become A Host
          </NavBarButtonContainer>
        </ButtonGroup>
      </NavBarContainer>
    );
  }
}
export default withRouter(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBar.tsx